// extracted by mini-css-extract-plugin
export default {"avatar":"CgSkD","menu":"yvQno","popoverContent":"QeJXB","mobileButton":"dF6gu"};